import Card from '@precis-digital/kurama/Card'
import Grid from '@precis-digital/kurama/Grid'
import { styled } from '@precis-digital/kurama/utils'
import Button from '@precis-digital/kurama/Button'
import Typography from '@precis-digital/kurama/Typography'

interface StyledCardProps {
  $active?: boolean
  $shadow?: boolean
  $condensedMargin?: boolean
  width?: string
}

interface StyledCardContentProps {
  $active?: boolean
}

export const StyledAvatarContainer = styled(Grid)(({ theme }) => ({
  textAlign: 'center',
  paddingBottom: '6px',
  maxWidth: '350px',
  '>div': {
    margin: '0 auto',
    marginTop: theme.spacing(4)
  },
  h2: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(0),
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  button: {
    display: 'inline-flex',
    marginBottom: '6px',
    marginTop: theme.spacing(3),
    width: '100%'
  }
}))

export const StyledCardContent = styled(Grid)<StyledCardContentProps>(({ $active: active, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minWidth: 0,
  flex: 1,
  cursor: active !== false ? 'pointer' : 'default',
  div: {
    ':first-of-type': {
      marginRight: theme.spacing(3)
    },
    '&:nth-of-type(2)': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: 'auto'
    }
  },
  h3: {
    maxWidth: '250px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  span: {
    maxWidth: '166px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}))

export const StyledGraySpan = styled('span')(({ theme }) => ({
  color: theme.tokens.foreground.main.secondary
}))

export const StyledCard = styled(Card)<StyledCardProps>(
  ({ $active: active, $shadow: shadow = false, $condensedMargin: condensedMargin = false, width, theme }) => ({
    maxWidth: '100%',
    width,
    marginTop: condensedMargin ? '8px' : '16px',
    marginBottom: condensedMargin ? '8px' : '16px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    button: {
      alignSelf: 'center',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      flexShrink: 0
    },
    ...(active !== false && {
      ':hover': {
        boxShadow: theme.elevation.mediumDepth
      }
    }),
    hr: {
      width
    },
    boxShadow: shadow ? theme.elevation.mediumDepth : 'none'
  })
)

export const StyledFlyoutFooter = styled('div')(({ theme }) => ({
  backgroundColor: theme.tokens.background.main.default,
  position: 'fixed',
  bottom: 0,
  marginTop: 'auto',
  width: '24rem',
  paddingBottom: '1rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  marginLeft: '-1rem',
  marginRight: '-1rem',
  borderBottomLeftRadius: theme.borderRadius.xLarge,
  borderBottomRightRadius: theme.borderRadius.xLarge,
  div: {
    ':first-of-type': {
      padding: 0,
      hr: {
        margin: '0 0 1rem 0'
      }
    }
  }
}))

export const StyledFullWidthButton = styled(Button)(({ theme }) => ({
  width: '100%'
}))

export const StyledFlyoutContainer = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(8),
  maxWidth: '350px',
  '>h3': {
    marginBottom: '16px'
  }
}))

export const StyledTypographyAnnotation = styled(Typography)(({ theme }) => ({
  color: theme.tokens.foreground.main.secondary
}))

export const EditInputContainer = styled(Grid)(({ theme }) => ({
  '>div': {
    width: '100%',
    paddingTop: '10px'
  }
}))
